import React from "react";
import { CloseCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AuthActions, { AuthSelectors } from "reducers/AuthRedux";
import "./Impersonate.scss";

function Impersonate() {
  const currentUser = useSelector((state) => state.user.user);
  const isImpersonating = useSelector(AuthSelectors.isImpersonating);
  const isImpersonationChanging = useSelector(AuthSelectors.isImpersonationChanging);
  const dispatch = useDispatch();

  const handleQuitImpersonation = () => {
    dispatch(AuthActions.toggleImpersonateUser());
  };

  if (!isImpersonating) return null;

  return (
    <div className="cr-impersonate-banner">
      <div className="wrapper">
        <span>Logged in as {currentUser.full_name}</span>

        <Button type="link" className="cr-impersonate-btn" onClick={handleQuitImpersonation}>
          {!isImpersonationChanging && <CloseCircleOutlined />}
          {isImpersonationChanging && <Spin indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />} />}
          Stop impersonation
        </Button>
      </div>
    </div>
  );
}

export default Impersonate;
